import { Organization, OrgSortColumn, Person, PersonSortColumn, SortOrder } from '../types';

export const sortOrganizations = (
  orgs: Organization[],
  sortColumn: OrgSortColumn,
  sortOrder: SortOrder,
): Organization[] => {
  return [...orgs].sort((a, b) => {
    let aValue: any;
    let bValue: any;

    switch (sortColumn) {
      case 'id':
        aValue = a.id;
        bValue = b.id;
        break;
      case 'name':
        aValue = a.name || '';
        bValue = b.name || '';
        break;
      case 'legal_entity':
        aValue = a.legal_entity || '';
        bValue = b.legal_entity || '';
        break;
      case 'address':
        aValue = a.address || '';
        bValue = b.address || '';
        break;
      case 'post_code':
        aValue = a.post_code || '';
        bValue = b.post_code || '';
        break;
      case 'town':
        aValue = a.town || '';
        bValue = b.town || '';
        break;
      case 'email':
        aValue = a.email || '';
        bValue = b.email || '';
        break;
      case 'updated_at':
        aValue = a.updated_at ? new Date(a.updated_at).getTime() : 0;
        bValue = b.updated_at ? new Date(b.updated_at).getTime() : 0;
        break;
      default:
        return 0;
    }

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return sortOrder === 'ASC' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    }

    if (sortOrder === 'ASC') {
      return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
    } else {
      return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
    }
  });
};

export const sortPersons = (
  persons: Person[],
  sortColumn: PersonSortColumn,
  sortOrder: SortOrder,
): Person[] => {
  return [...persons].sort((a, b) => {
    let aValue: any;
    let bValue: any;

    switch (sortColumn) {
      case 'id':
        aValue = a.id;
        bValue = b.id;
        break;
      case 'name':
        aValue = a.name || '';
        bValue = b.name || '';
        break;
      case 'first_name':
        aValue = a.first_name || '';
        bValue = b.first_name || '';
        break;
      case 'last_name':
        aValue = a.last_name || '';
        bValue = b.last_name || '';
        break;
      case 'email':
        aValue = a.email || '';
        bValue = b.email || '';
        break;
      case 'phone':
        aValue = a.phone || '';
        bValue = b.phone || '';
        break;
      case 'org_name':
        aValue = a.org_name || '';
        bValue = b.org_name || '';
        break;
      case 'active_flag':
        aValue = a.active_flag ? 1 : 0;
        bValue = b.active_flag ? 1 : 0;
        break;
      case 'updated_at':
        aValue = a.updated_at ? new Date(a.updated_at).getTime() : 0;
        bValue = b.updated_at ? new Date(b.updated_at).getTime() : 0;
        break;
      default:
        return 0;
    }

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return sortOrder === 'ASC' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
    }

    if (sortOrder === 'ASC') {
      return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
    } else {
      return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
    }
  });
};

